export enum PayJoyCardStatus {
  CREATED = "CREATED",
  PENDING = "PENDING",
  TRACKED = "TRACKED",
  IN_WAREHOUSE = "IN_WAREHOUSE",
  IN_TRANSIT = "IN_TRANSIT",
  DISTRIBUTION = "DISTRIBUTION",
  DELIVERED = "DELIVERED",
  ACTIVE = "ACTIVE",
  BLOCKED = "BLOCKED",
  FROZEN = "FROZEN",
  NONE = "NONE",
  DISABLED = "DISABLED",
  ELIGIBLE = "ELIGIBLE",
  INSTORE_NEEDS_ACTIVATION = "INSTORE_NEEDS_ACTIVATION",
  REPORTED_UNDELIVERED = "REPORTED_UNDELIVERED",
  FAILED_DELIVERY_ATTEMPT = "FAILED_DELIVERY_ATTEMPT",
  // Error
  DELIVERY_FAILED = "DELIVERY_FAILED",
  REJECTED = "REJECTED",
  CANCELED = "CANCELED",
}
